import React from 'react';
import { Translation } from 'react-i18next';

type Options = {
  value: string;
  gaLabel: string;
  label: React.JSX.Element | string;
  tip?: React.JSX.Element;
}[];

export const TypesOptions = [
  {
    label: <Translation>{t => t('StreamFilter.1hg3k')}</Translation>,
    value: 'post',
    gaLabel: 'Post',
  },
  {
    label: 'Quest',
    value: 'quest',
    gaLabel: 'Quest',
  },
  {
    label: <Translation>{t => t('StreamFilter.r4g9fg')}</Translation>,
    value: 'draw',
    gaLabel: 'Luck Draw',
  },
  {
    label: <Translation>{t => t('StreamFilter.1johj4i')}</Translation>,
    value: 'data_proposal',
    gaLabel: 'Proposal',
  },
  {
    label: <Translation>{t => t('StreamFilter.1hfxb')}</Translation>,
    value: 'poll',
    gaLabel: 'Poll',
  },
  {
    label: 'AskPro',
    value: 'pay_qa',
    gaLabel: 'AskPro',
  },
  {
    label: <Translation>{t => t('StreamFilter.4n9zys')}</Translation>,
    value: 'pay_thread',
    gaLabel: 'Paid post',
  },
  {
    label: <Translation>{t => t('StreamFilter.prime')}</Translation>,
    value: 'prime_pick',
    tip: <Translation>{t => t('StreamFilter.primeTip')}</Translation>,
    gaLabel: 'PrimePost',
  },
  {
    label: <Translation>{t => t('StreamFilter.original')}</Translation>,
    value: 'original',
    gaLabel: 'Original Post',
  },
  {
    label: <Translation>{t => t('StreamFilter.jxa3cz')}</Translation>,
    value: 'promotion',
    gaLabel: 'Promotion',
  },
];

export const UsdValueOptions = [
  { label: '> $1,000', value: '1000', gaLabel: '> $1,000' },
  { label: '> $10,000', value: '10000', gaLabel: '> $10,000' },
  { label: '> $100,000', value: '100000', gaLabel: '> $100,000' },
  { label: '> $1,000,000', value: '1000000', gaLabel: '> $1,000,000' },
  { label: '> $10,000,000', value: '10000000', gaLabel: '> $10,000,000' },
];

export const CreateAtOptions = [
  // value为day，发送请求的时候再转化为时间戳（秒）
  {
    label: <Translation>{t => t('StreamFilter.12qbdj5')}</Translation>,
    value: '1',
    gaLabel: 'Recent 24h',
  },
  {
    label: <Translation>{t => t('StreamFilter.12qbh6w')}</Translation>,
    value: '3',
    gaLabel: 'Recent 72h',
  },
  {
    label: <Translation>{t => t('StreamFilter.e90yx')}</Translation>,
    value: '7',
    gaLabel: 'Recent 7days',
  },
];

const generateOptionMap = (options: Options) => {
  return options.reduce(
    (prv, cur) => {
      prv[cur.value] = cur.gaLabel;
      return prv;
    },
    {} as Record<string, string>,
  );
};

export const TypesMap = generateOptionMap(TypesOptions as Options);
export const CreateAtMap = generateOptionMap(CreateAtOptions as Options);
export const UsdValueMap = generateOptionMap(UsdValueOptions as Options);
